export class TaskFilters {
  status?: string[];
  priority?: string[];
  assignees?: string[] | string;
  dueBefore?: string;
  dueAfter?: string;
  applicationStatusId?: string;
  search?: string;
  showStandaloneTasksOnly?: boolean;
  isArchived?: boolean;
}
